// js/core/payroll-export.js — the QuickBooks CSV over W2's splitPayroll rows
// (Payroll Summary + Time Detail). Pure formatting: every number, note and
// version word comes out of splitPayroll; nothing is recomputed here.
import { csvFilename } from './csv.js';
import { sickKeysOf, sickKey } from './timesheet-activity.js';
export { monD } from './time-clock.js';   // one implementation of "Oct 20" (G7)

export const hhmm = hours => {
  const m = Math.round(hours * 60);
  return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
};

export const payrollNotes = row => (row.notes || []).join('; ');

const fix2 = key => ({ key, label: key, map: r => Number(r[key] || 0).toFixed(2) });

export const PAYROLL_SUMMARY_COLUMNS = [
  { key: 'WeekEnding', label: 'WeekEnding' }, { key: 'Employee', label: 'Employee' }, { key: 'EmployeeID', label: 'EmployeeID' },
  fix2('RegularHours'), fix2('OvertimeHours'), fix2('DoubleOvertimeHours'), fix2('SickHours'), fix2('VacationHours'), fix2('StatHolidayHours'),
  { key: 'StatDaysNotWorked', label: 'StatDaysNotWorked', map: r => String(r.StatDaysNotWorked || 0) },
  fix2('TotalHours'),
  { key: 'notes', label: 'Notes', map: payrollNotes },
];

export const TIME_DETAIL_COLUMNS = [
  { key: 'work_date', label: 'TxnDate' }, { key: 'Employee', label: 'Employee' }, { key: 'EmployeeID', label: 'EmployeeID' },
  { key: 'Customer', label: 'Customer' }, { key: 'ServiceItem', label: 'ServiceItem' }, { key: 'PayrollItem', label: 'PayrollItem' },
  { key: 'Hours', label: 'Hours', map: r => Number(r.Hours).toFixed(2) },
  { key: 'Hours', label: 'Duration', map: r => hhmm(r.Hours) },
  { key: 'ClockIn', label: 'ClockIn' }, { key: 'ClockOut', label: 'ClockOut' },
  { key: 'BreakMinutes', label: 'BreakMinutes', map: r => r.BreakMinutes === '' ? '' : Number(r.BreakMinutes || 0) },
  { key: 'BillableStatus', label: 'BillableStatus', map: () => 'NotBillable' },
  { key: 'Class', label: 'Class', map: () => '' },
  { key: 'Description', label: 'Description' },
];

export function exportFilenames(scope, monday, sunday, version) {
  const v = version > 1 ? ' v' + version : '', period = { from: monday, to: sunday };
  return { summary: csvFilename('Payroll Summary' + v, scope || 'all projects', period), detail: csvFilename('Time Detail' + v, scope || 'all projects', period) };
}

// The ids of the paid sick ROWS (contract §2.5 input.sickKeys): one task-less
// row per ledger key. Row ids, never worker|date — same-day work stays work.
export function payrollSickKeys(entries, sickDays) {
  const paid = sickKeysOf(sickDays);
  return new Set((entries || []).filter(e => !e.task_id && paid.has(sickKey(e.worker_id, e.work_date, e.submission_id || ''))).map(e => e.id));
}

// 'Admin correction (Name, date): R 8→7, OT 0→0 — reason' → 'reason'
export function adminEditReason(notes) {
  const s = String(notes ?? '');
  const i = s.indexOf(' — ');
  return (i < 0 ? s : s.slice(i + 3)).trim();
}
